import { render, staticRenderFns } from "./DetailLaporanGadaiBaru.vue?vue&type=template&id=0c9a6826&"
import script from "./DetailLaporanGadaiBaru.vue?vue&type=script&lang=js&"
export * from "./DetailLaporanGadaiBaru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports